import { billingPromoEn, billingPromoEs } from './billingPromo';

const billingCoreEn = {
  userMenuSubscription: 'Subscription',
  subscriptionTitle: 'Subscription',
  subscriptionLoading: 'Loading subscription…',
  subscriptionPlan: 'Plan',
  subscriptionStatus: 'Status',
  subscriptionUsage: 'Usage',
  subscriptionHouses: 'Houses',
  subscriptionSeats: 'Staff seats',
  subscriptionRenewal: 'Next renewal',
  subscriptionRenewalAmount: 'Renewal amount',
  subscriptionTrialEnds: 'Trial ends',
  subscriptionAmountDue: 'Amount due',
  subscriptionPaymentMethod: 'Payment method',
  subscriptionPaymentRail: 'Payment channel',
  subscriptionNoPaymentMethod: 'No payment method on file',
  subscriptionChangePlan: 'Change plan',
  subscriptionCurrentPlan: 'Current plan',
  subscriptionSelectPlan: 'Select',
  subscriptionCancel: 'Cancel subscription',
  subscriptionResume: 'Resume subscription',
  subscriptionCancelPending: 'Cancels at the end of the period',
  subscriptionStartTrial: 'Start 7-day trial',
  subscriptionInvoices: 'Invoices',
  subscriptionNoInvoices: 'No invoices yet',
  subscriptionPayments: 'Payments',
  subscriptionNoPayments: 'No payments yet',
  subscriptionManualPayment: 'Send proof of payment',
  subscriptionManualMethod: 'Method',
  subscriptionManualAmount: 'Amount',
  subscriptionManualCurrency: 'Currency',
  subscriptionManualReference: 'Reference',
  subscriptionManualProof: 'Proof URL',
  subscriptionManualNote: 'Note',
  subscriptionManualSubmit: 'Submit for review',
  subscriptionManualSent: 'Proof submitted for review',
  subscriptionUnlimited: 'Unlimited',
  subscriptionPerMonth: '/mo',
  subscriptionAddMethod: 'Add payment method',
  subscriptionUpdateMethod: 'Update card',
  subscriptionRetryVerify: 'Retry verification',
  subscriptionManageBilling: 'Manage billing',
  subscriptionCheckout: 'Subscribe',
  subscriptionVerifyHint:
    'We authorize the first month on your card and release it immediately to confirm funds.',
  subscriptionConnectTitle: 'Online collections',
  subscriptionConnectHint:
    'Open a Stripe account to charge your players online; payouts land in your own account.',
  subscriptionConnectFee: 'The platform keeps {fee} of each online charge. Cash pays no fee.',
  subscriptionConnectPending: 'Stripe still needs',
  subscriptionConnectStart: 'Set up online collections',
  subscriptionConnectResume: 'Finish setup',
  subscriptionConnectDashboard: 'View payouts',
  connectStatus_none: 'Not set up',
  connectStatus_pending: 'Pending review',
  connectStatus_ready: 'Active',
  subscriptionCryptoTitle: 'Pay with crypto',
  subscriptionCryptoHint:
    'Crypto has no automatic renewal: you prepay the period and the plan activates '
    + 'once the payment is confirmed on chain.',
  subscriptionPayCrypto: 'Prepay in crypto',
  methodStatus_none: 'Not set up',
  methodStatus_pending: 'Verification in progress',
  methodStatus_verified: 'Verified',
  methodStatus_failed: 'Verification failed',
  billingFailInsufficientFunds: 'Not enough funds. Top up the card or use another one.',
  billingFailCardDeclined: 'The bank declined the card. Contact your bank or use another card.',
  billingFailDoNotHonor: 'The bank rejected the charge. Try again or use another card.',
  billingFailExpiredCard: 'The card expired. Add a new one.',
  billingFailIncorrectCvc: 'The security code is wrong. Add the card again.',
  billingFailProcessingError: 'The processor failed. Try again in a few minutes.',
  billingFailAuthRequired: 'Your bank asked for confirmation. Approve it and try again.',
  billingFailNotSupported: 'This card is not supported. Use another one.',
  billingFailGeneric: 'The card could not be verified. Try another payment method.',
  subscriptionActionFailed: 'Could not complete the action. Try again.',
  subscriptionQuotaBlocked: 'Reduce houses or seats before downgrading',
  planStatus_trialing: 'Trial',
  planStatus_active: 'Active',
  planStatus_past_due: 'Payment pending',
  planStatus_degraded: 'Limited',
  planStatus_suspended: 'Suspended',
  planStatus_canceled: 'Canceled',
  planStatus_expired: 'Expired',
  planName_basic: 'Basic',
  planName_advanced: 'Advanced',
  planName_platinum: 'Platinum',
  planName_founder: 'Founder',
  payMethod_zelle: 'Zelle',
  payMethod_venmo: 'Venmo',
  payMethod_transfer: 'Bank transfer',
  payMethod_cash: 'Cash',
  invoiceState_open: 'Open',
  invoiceState_partially_paid: 'Partially paid',
  invoiceState_paid: 'Paid',
  invoiceState_overpaid: 'Overpaid',
  trialBannerTitle: 'Trial ends in {days} days',
  trialBannerAction: 'Review plan',
  pastDueBannerTitle: 'Payment pending: {amount}',
  pastDueBannerAction: 'Pay now',
  billingOnboardTitle: 'Choose your plan and how you pay',
  billingOnboardHint:
    'You have 7 days free on the plan you pick. After that, billing starts on the channel you choose. Cash sends an automatic reminder 24 hours before each due date.',
  billingOnboardContinue: 'Continue',
  billingOnboardRailCard: 'Card (Stripe)',
  billingOnboardRailCardHint: 'Automatic renewal after the trial',
  billingOnboardRailCash: 'Cash',
  billingOnboardRailCashHint: 'Pay in cash; we remind you 24h before',
  billingOnboardRailCrypto: 'Crypto',
  billingOnboardRailCryptoHint: 'Prepay each period on chain',
  registerBillingPlan: 'Subscription plan',
  registerBillingPlanHint: 'Optional. Leave empty to skip billing for this banker.',
  registerBillingPlanNone: 'No plan (no subscription menu)',
  'billing/seat-quota-exceeded': 'This plan has no more staff seats. Upgrade or remove a user.',
};

const billingCoreEs = {
  userMenuSubscription: 'Suscripción',
  subscriptionTitle: 'Suscripción',
  subscriptionLoading: 'Cargando suscripción…',
  subscriptionPlan: 'Plan',
  subscriptionStatus: 'Estado',
  subscriptionUsage: 'Uso',
  subscriptionHouses: 'Casas',
  subscriptionSeats: 'Plazas de personal',
  subscriptionRenewal: 'Próxima renovación',
  subscriptionRenewalAmount: 'Importe de renovación',
  subscriptionTrialEnds: 'El trial termina',
  subscriptionAmountDue: 'Monto pendiente',
  subscriptionPaymentMethod: 'Medio de pago',
  subscriptionPaymentRail: 'Canal de pago',
  subscriptionNoPaymentMethod: 'Sin medio de pago registrado',
  subscriptionChangePlan: 'Cambiar de plan',
  subscriptionCurrentPlan: 'Plan actual',
  subscriptionSelectPlan: 'Elegir',
  subscriptionCancel: 'Cancelar suscripción',
  subscriptionResume: 'Reanudar suscripción',
  subscriptionCancelPending: 'Se cancela al final del periodo',
  subscriptionStartTrial: 'Iniciar trial de 7 días',
  subscriptionInvoices: 'Facturas',
  subscriptionNoInvoices: 'Aún no hay facturas',
  subscriptionPayments: 'Pagos',
  subscriptionNoPayments: 'Aún no hay pagos',
  subscriptionManualPayment: 'Enviar comprobante de pago',
  subscriptionManualMethod: 'Método',
  subscriptionManualAmount: 'Importe',
  subscriptionManualCurrency: 'Moneda',
  subscriptionManualReference: 'Referencia',
  subscriptionManualProof: 'URL del comprobante',
  subscriptionManualNote: 'Nota',
  subscriptionManualSubmit: 'Enviar a revisión',
  subscriptionManualSent: 'Comprobante enviado a revisión',
  subscriptionUnlimited: 'Ilimitado',
  subscriptionPerMonth: '/mes',
  subscriptionAddMethod: 'Añadir medio de pago',
  subscriptionUpdateMethod: 'Actualizar tarjeta',
  subscriptionRetryVerify: 'Reintentar verificación',
  subscriptionManageBilling: 'Gestionar facturación',
  subscriptionCheckout: 'Suscribirme',
  subscriptionVerifyHint:
    'Autorizamos el primer mes en tu tarjeta y lo liberamos al instante para confirmar fondos.',
  subscriptionConnectTitle: 'Cobros en línea',
  subscriptionConnectHint:
    'Abre una cuenta de Stripe para cobrar en línea a tus jugadores; los pagos llegan a tu propia cuenta.',
  subscriptionConnectFee: 'La plataforma retiene {fee} de cada cobro en línea. El efectivo no paga comisión.',
  subscriptionConnectPending: 'Stripe aún necesita',
  subscriptionConnectStart: 'Configurar cobros en línea',
  subscriptionConnectResume: 'Completar configuración',
  subscriptionConnectDashboard: 'Ver pagos recibidos',
  connectStatus_none: 'Sin configurar',
  connectStatus_pending: 'En revisión',
  connectStatus_ready: 'Activo',
  subscriptionCryptoTitle: 'Pagar con cripto',
  subscriptionCryptoHint:
    'Cripto no tiene renovación automática: prepagas el periodo y el plan se activa '
    + 'cuando el pago se confirma en la cadena.',
  subscriptionPayCrypto: 'Prepagar en cripto',
  methodStatus_none: 'Sin configurar',
  methodStatus_pending: 'Verificación en curso',
  methodStatus_verified: 'Verificado',
  methodStatus_failed: 'Verificación fallida',
  billingFailInsufficientFunds: 'Fondos insuficientes. Recarga la tarjeta o usa otra.',
  billingFailCardDeclined: 'El banco rechazó la tarjeta. Contáctalo o usa otra tarjeta.',
  billingFailDoNotHonor: 'El banco rechazó el cargo. Inténtalo de nuevo o usa otra tarjeta.',
  billingFailExpiredCard: 'La tarjeta está vencida. Añade una nueva.',
  billingFailIncorrectCvc: 'El código de seguridad es incorrecto. Vuelve a añadir la tarjeta.',
  billingFailProcessingError: 'Falló el procesador. Inténtalo en unos minutos.',
  billingFailAuthRequired: 'Tu banco pidió confirmación. Apruébala e inténtalo de nuevo.',
  billingFailNotSupported: 'Esta tarjeta no está soportada. Usa otra.',
  billingFailGeneric: 'No se pudo verificar la tarjeta. Prueba con otro medio de pago.',
  subscriptionActionFailed: 'No se pudo completar la acción. Inténtalo de nuevo.',
  subscriptionQuotaBlocked: 'Reduce casas o plazas antes de bajar de plan',
  planStatus_trialing: 'Trial',
  planStatus_active: 'Activa',
  planStatus_past_due: 'Pago pendiente',
  planStatus_degraded: 'Limitada',
  planStatus_suspended: 'Suspendida',
  planStatus_canceled: 'Cancelada',
  planStatus_expired: 'Vencida',
  planName_basic: 'Básico',
  planName_advanced: 'Avanzado',
  planName_platinum: 'Platinum',
  planName_founder: 'Fundador',
  payMethod_zelle: 'Zelle',
  payMethod_venmo: 'Venmo',
  payMethod_transfer: 'Transferencia bancaria',
  payMethod_cash: 'Efectivo',
  invoiceState_open: 'Abierta',
  invoiceState_partially_paid: 'Pago parcial',
  invoiceState_paid: 'Pagada',
  invoiceState_overpaid: 'Sobrepagada',
  trialBannerTitle: 'El trial termina en {days} días',
  trialBannerAction: 'Ver plan',
  pastDueBannerTitle: 'Pago pendiente: {amount}',
  pastDueBannerAction: 'Pagar ahora',
  billingOnboardTitle: 'Elige tu plan y cómo vas a pagar',
  billingOnboardHint:
    'Tienes 7 días gratis con el plan que elijas. Después se activa el cobro por el canal escogido. Efectivo envía un aviso automático 24 horas antes de cada vencimiento.',
  billingOnboardContinue: 'Continuar',
  billingOnboardRailCard: 'Tarjeta (Stripe)',
  billingOnboardRailCardHint: 'Renovación automática al terminar el trial',
  billingOnboardRailCash: 'Efectivo',
  billingOnboardRailCashHint: 'Pagas en efectivo; te avisamos 24h antes',
  billingOnboardRailCrypto: 'Cripto',
  billingOnboardRailCryptoHint: 'Prepagas cada periodo en cadena',
  registerBillingPlan: 'Plan de suscripción',
  registerBillingPlanHint: 'Opcional. Déjalo vacío para no facturar a este banker.',
  registerBillingPlanNone: 'Sin plan (sin menú de suscripción)',
  'billing/seat-quota-exceeded': 'Este plan no admite más plazas de personal. Mejora el plan o quita un usuario.',
};

/** Full billing dictionary (core subscription + god/promo). */
export const billingEn = {
  ...billingCoreEn,
  ...billingPromoEn,
};

export const billingEs = {
  ...billingCoreEs,
  ...billingPromoEs,
};
